// extracted by mini-css-extract-plugin
export default {"container":"TopMenu_container__KefE-","is-webview-app":"TopMenu_is-webview-app__JAg4i","app-only":"TopMenu_app-only__htKfR"};